<template>
  <div>
    <div class="search-row">
      <div class="search-item">
        <span>打印日期：</span>
        <el-date-picker value-format="yyyy-MM-dd" v-model="queryParams.print_date" type="daterange" clearable :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`"> </el-date-picker>
      </div>
      <div class="search-item">
        <span>发放科室：</span>
        <el-select class="input300" v-model="queryParams.out_department_id" filterable clearable remote :placeholder="`请选择`" :remote-method="getDep" @focus="getDep('')">
          <el-option v-for="item in depOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </div>
      <div class="search-item">
        <span>器械包名称：</span>
        <el-select class="width-fixed" v-model="queryParams.instrumentset_id" filterable clearable remote :placeholder="`请选择`" :remote-method="searchInstruments" @focus="searchInstruments('')" value-key="name">
          <el-option v-for="item in instrumentsetList" :key="item.pk_id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="button-box">
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
        <el-button size="mini" type="primary" @click="exportExcel">导出</el-button>
        <el-button size="mini" type="primary" @click="generateChart">生成图表</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="totalCost">总计费用（元）： {{ totalCost }}</div>
    <el-table class="mt10" ref="multipleTable" border :data="list" @sort-change="sortChange">
      <el-table-column type="index" label="#" width="55"></el-table-column>
      <el-table-column :sortable="!!item.sortKey ? 'custom' : false" :sort-by="item.sortKey" v-for="item in columns" :label="item.text" :key="item.column" :width="item.width">
        <template slot-scope="scope">
          <!-- 操作 -->
          <template v-if="item.column == 'handle'">
            <el-button type="text" @click="openDialog(scope.row)">查看</el-button>
          </template>
          <span v-else>{{ scope.row[item.column] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :queryParams="queryParams" :getList="getList" />

    <!-- 查看 -->
    <el-dialog :title="`详情`" :visible.sync="dialogVisible" width="1360px">
      <el-table class="mt10" ref="multipleTable" border :data="detailList" @sort-change="sortChangeDetail">
        <el-table-column type="index" label="#" width="55"></el-table-column>
        <el-table-column :sortable="!!item.sortKey ? 'custom' : false" :sort-by="item.sortKey" v-for="item in detailColumns" :label="item.text" :key="item.column" :width="item.width">
          <template slot-scope="scope">
            <span>{{ scope.row[item.column] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="detailQueryParams" :getList="getDetailList" />
    </el-dialog>

    <!-- 生成图表 -->
    <el-dialog :title="`详情`" :visible.sync="chartShow" width="1360px">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane :label="`按发放科室`" name="1">
          <div class="charts-disc">
            <div class="charts-title">
              <span v-if="queryParams.print_date && queryParams.print_date.length != 0">{{ queryParams.print_date[0] }} 到 {{ queryParams.print_date[1] }}</span>
              按科室费用汇总
            </div>
          </div>
          <div class="byDepaDistEleBox">
            <div id="byDepaDistEle" class="byDepaDistEle"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="`按器械包`" name="2">
          <div class="charts-disc">
            <div class="charts-title">
              <span v-if="queryParams.print_date && queryParams.print_date.length != 0">{{ queryParams.print_date[0] }} 到 {{ queryParams.print_date[1] }}</span>
              按器械包费用汇总
            </div>
            <div>
              <span>科室名称：</span>
              <el-select size="mini" class="input300" v-model="chartDepa" filterable clearable remote :placeholder="`请选择`" :remote-method="getDep" @focus="getDep('')" @change="getChartList">
                <el-option v-for="item in depOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="byDepaDistEleBox">
            <div id="byPackCostEle" class="byDepaDistEle"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination';
import { printCostDetail, printCost, instrumentPackageOptions, departmentOptions, printCostCreateChart } from '@/api.js';
import { pageSize } from '@/utils/Config';
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      dialogVisible: false,
      list: [],
      columns: [],
      queryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },

      instrumentsetList: [], // 科室
      depOptions: [], //部门
      totalCost: 0,
      detailList: [],
      detailColumns: [],
      detailQueryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      chartShow: false,
      activeName: '1',
      chartDepa: '',
    };
  },
  created() {
    this.setDate();
    this.getList();
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    // 监听tab切换
    handleKeyDown(event) {
      if (event.key === 'Tab' && this.chartShow) {
        event.preventDefault(); // 阻止默认的Tab键行为
        this.activeName = this.activeName == '1' ? '2' : '1'
        this.handleTabClick()
      }
    },
    // 设置日期默认值
    setDate() {
      const currentDate = new Date();
      const firstDay = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
      const lastDay = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0));
      this.$set(this.queryParams, 'print_date', [firstDay, lastDay]);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 图表数据处理
    createSupplierInformation(res, element) {
      let datas = {
        xAxisData: [],
        series: [],
      };
      let seriesArr = [];
      res.forEach((item, index) => {
        datas.xAxisData.push(item.print_date);
        item.detail.forEach((itemJ) => {
          if (!seriesArr.includes(itemJ.id)) {
            datas.series.push({
              dataId: itemJ.id,
              name: itemJ.name || `无发放科室`,
              type: 'bar',
              stack: 'total',
              barWidth: '60%',
              label: {
                show: true,
                formatter: (params) => (params.value == 0 ? '' : params.value),
              },
              data: [],
            });
            seriesArr.push(itemJ.id);
          }
        });
      });
      datas.series.forEach((itemI) => {
        res.forEach((itemJ) => {
          let isHave = false;
          itemJ.detail.forEach((itemK) => {
            if (itemI.dataId == itemK.id) {
              let roundedNum = parseFloat(itemK.cost).toFixed(2); // 保留两位小数
              itemI.data.push(roundedNum);
              isHave = true;
            }
          });
          if (!isHave) {
            itemI.data.push(0);
          }
        });
      });

      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          selectedMode: false,
          orient: 'vertical', // 设置图例以垂直方向展示
          right: 0, // 设置图例在右边，距离右边框的距离为 10
          top: 'middle', // 设置图例在上方，距离顶部的距离为 20
          y: '-40px',
          margin: [0, 0, 0, 10], // 添加图表和图例之间的间距
        },
        grid: {
          left: 30,
          right: 200,
          top: 10,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: function (value) {
              // 将小数值转换为整数
              if (value < 1) {
                return '';
              } else {
                return value;
              }
            },
          },
        },
        xAxis: {
          type: 'category',
          data: datas.xAxisData,
        },
        series: datas.series,
      };
      this.createMap(element, option);
    },
    // 创建echarts表格 的公共函数
    createMap(eleId, option) {
      var myChart = this.$echarts.getInstanceByDom(document.getElementById(eleId));
      if (myChart) {
        // 图表实例存在，执行更新操作
        myChart.setOption(option,true);
      } else {
        // 图表实例不存在，执行创建操作
        myChart = this.$echarts.init(document.getElementById(eleId));
        myChart.setOption(option,true);
      }
    },

    // 切换弹框中的tab页
    handleTabClick() {
      this.getChartList();
    },

    // 打卡弹框并且生成图表
    generateChart() {
      this.chartShow = true;
      this.activeName = '1';
      this.chartDepa = this.queryParams.out_department_id;
      this.getChartList();
    },

    //获取图表的列表
    getChartList() {
      const { print_date, instrumentset_id } = this.queryParams;
      let out_department_id = ''
      if (this.activeName == 1) {
        // 按发放科室的科室名称是外面搜索栏中的科室名称。
        out_department_id = this.queryParams.out_department_id
      } else if (this.activeName == 2) {
        // 按器械包的科室名称是在那个tab里选择的。
        out_department_id = this.chartDepa
      }
      const query = {
        out_department_id,
        instrumentset_id,
        type: this.activeName,
      };
      if (print_date && print_date.length != 0) {
        query.start_date = print_date[0];
        query.end_date = print_date[1];
      }
      this.$request('get', printCostCreateChart, query).then((res) => {
        if (res) {
          if (this.activeName == 1) {
            this.$nextTick(() => {
              this.createSupplierInformation(res, 'byDepaDistEle');
            });
          } else if (this.activeName == 2) {
            this.createSupplierInformation(res, 'byPackCostEle');
          }
        }
      });
    },

    // 导出表格
    exportExcel() {
      const { print_date, out_department_id, instrumentset_id } = this.queryParams;
      const query = {
        out_department_id,
        instrumentset_id,
        is_export: 1,
      };
      if (print_date && print_date.length != 0) {
        query.start_date = print_date[0];
        query.end_date = print_date[1];
      }
      this.$utils.exportFile(printCost, query);
    },
    // 获取科室
    getDep(query) {
      const params = {
        name: query || '',
      };
      this.$request('get', departmentOptions, params).then((res) => {
        this.depOptions = res;
      });
    },
    //获取器械包
    searchInstruments(query) {
      const params = {
        search: query || '',
      };
      this.$request('post', instrumentPackageOptions, params).then((res) => {
        this.instrumentsetList = res;
      });
    },
    // 获取列表数据
    getList() {
      const { pageIndex, pageSize, print_date, out_department_id, instrumentset_id } = this.queryParams;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        out_department_id,
        instrumentset_id,
      };
      if (print_date && print_date.length != 0) {
        query.start_date = print_date[0];
        query.end_date = print_date[1];
      }
      this.$request('get', printCost, query).then((res) => {
        if (res) {
          this.list = res.data;
          this.columns = res.columns;
          this.queryParams._total = res.total;
          this.totalCost = res.total_cost;
        }
      });
    },
    // 获取列表详情数据
    getDetailList(data) {
      const { print_date, instrumentset_id, out_department_id } = data;
      const query = {
        print_date,
        instrumentset_id,
        out_department_id,
      };
      this.$request('get', printCostDetail, query).then((res) => {
        if (res) {
          this.detailList = res.data;
          this.detailColumns = res.columns;
          this.detailQueryParams._total = res.total;
        }
      });
    },

    // 搜索
    search() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },

    // 查看
    openDialog(data) {
      this.dialogVisible = true;
      this.getDetailList(data);
    },

    // 排序方法
    sortChange(item) {
      const { column, order } = item;
      const orderString = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined;
      const orderBy = order ? column.sortBy : undefined;

      this.queryParams.order = orderString;
      this.queryParams.orderBy = orderBy;
      this.getList();
    },
    sortChangeDetail(item) {
      const { column, order } = item;
      const orderString = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined;
      const orderBy = order ? column.sortBy : undefined;

      this.detailQueryParams.order = orderString;
      this.detailQueryParams.orderBy = orderBy;
      this.getDetailList();
    },
  },
};
</script>

<style scoped lang="scss">
.search-row {
  display: flex;
}
.search-item {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 20px;
  span {
    display: inline;
  }
}
.byDepaDistEleBox {
  text-align: center;
}
.byDepaDistEle {
  display: inline-block;
  width: 1100px;
  height: 500px;
}
.charts-disc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.charts-title {
  font-size: 25px;
}
.totalCost{
  margin-top: 10px;
}
.button-box{
  display: flex;
  align-items: center;
}
</style>
